import { render, staticRenderFns } from "./DeviceLayout.vue?vue&type=template&id=5bed3359"
import script from "./DeviceLayout.vue?vue&type=script&lang=ts"
export * from "./DeviceLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports